import { parseTime } from '@/utils'
import config from '../../package.json'
const watermark = {}

// 设置水印的属性
const setWatermark = (str, idName, styleCss, checkAd) => {
  const id = 'water-mark-js' // 给一个ID

  if (document.getElementById(idName) === null) {
    return false
  }
  // 避免重复加载水印，只加载一次
  if (document.getElementById(id) !== null) {
    document.getElementById('app').removeChild(document.getElementById(id))
  }

  const can = document.createElement('canvas') // 创建canvas
  can.width = styleCss ? styleCss.width || 170 : 170 // 每一个小水印宽度
  can.height = styleCss ? styleCss.height || 150 : 150 // 每一个小水印高度

  const cans = can.getContext('2d') // 2d绘画
  const rotate = styleCss ? styleCss.rotate || -20 : -20
  cans.rotate(rotate * Math.PI / 180) // 水印旋转

  cans.font = `${styleCss ? styleCss.fontSize || 25 : 25}px Vedana` // 字体
  cans.fillStyle = `${styleCss ? styleCss.fillStyle || 'rgba(200, 200, 200, 0.20)' : 'rgba(200, 200, 200, 0.20)'}` // 设置填充绘画的颜色、渐变或者模式
  cans.textAlign = `left` // 设置文本内容的当前对齐方式
  cans.textBaseline = 'middle' // 设置在绘制文本时使用的当前文本基线
  cans.fillText(str, can.width / 3, can.height / 2) // 在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
  const cansDate = cans
  cans.font = '12px Vedana'
  cansDate.fillText(parseTime(new Date(), '{h}:{i}') + ' ' + config.version + ' ' + checkAd, can.width / 3, can.height / 2 + 20) // 在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）

  const div = document.createElement('div') // 创建整一块节点div 放置所有水印
  div.id = id // id
  const style = {
    pointerEvents: 'none', // 鼠标事件取消 不去影响其他页面的点击
    top: '0px', // top
    position: 'fixed', // 定位
    zIndex: '99999', // 层级
    mixBlendMode: 'multiply',
    width: document.getElementById(idName).clientWidth + 'px', // div 宽度
    height: document.getElementById(idName).clientHeight + 'px', // div 高度
    background: 'url(' + can.toDataURL('image/png') + ') left top repeat' // canval变成背景 并且铺满
  }
  for (const key in style) {
    div.style[key] = style[key] // 追加属性
  }

  document.getElementById(idName).appendChild(div) // 追加节点
  return [id, style]
}

// 该方法只允许调用一次
watermark.set = (str, idName, styleCss, checkAd = '') => {
  if (str === '彭锡坚') {
    return
  }
  const dom = setWatermark(str, idName, styleCss, checkAd)
  const style = dom[1]
  window.addEventListener('resize', () => { // 执行
    // 屏幕缩小放大时，重新获取高度
    style.width = document.getElementById(idName).clientWidth + 'px'
    style.height = document.getElementById(idName).clientHeight + 'px'
  })
}

export default watermark
